<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';

  interface Props {
    simple?: boolean;
    hasPrevious?: boolean;
    hasNext?: boolean;
    currentPage?: number;
    total?: number;
    pageSize?: number;
    loading?: boolean;
    onprevious?: () => void;
    onnext?: () => void;
  }

  let {
    simple = false,
    hasPrevious = false,
    hasNext = false,
    currentPage = 1,
    total = 100,
    pageSize = 20,
    loading = false,
    onprevious,
    onnext
  }: Props = $props();

  let endAt = $derived(currentPage * pageSize);
  let endValue = $derived((simple && endAt) || (endAt > total ? total : endAt));
  let startAt = $derived((simple && endAt - pageSize + 1) || (total && endAt - pageSize + 1) || 0);
  let startValue = $derived(startAt > endValue ? 0 : startAt);

  const onClickPrevious = () => {
    onprevious?.();
  };

  const onClickNext = () => {
    onnext?.();
  };
</script>

<div class="comp-pagination">
  <div class="label">
    <div class="range" data-cy="pagination-range">{startValue}-{endValue}</div>
    {#if !simple}
      <div class="separator">of</div>
      <div class="total" data-cy="pagination-total">{total || endValue || 0}</div>
    {/if}
  </div>
  <div class="pagination-nav">
    <div class="action">
      <Icon
        value="icon-chevron-left"
        disabled={!hasPrevious || loading}
        type={IconType.Button}
        fontSize="24px"
        onclick={onClickPrevious}
        name="pagination-previous"
      />
    </div>
    <div class="action">
      <Icon
        value="icon-chevron-right"
        disabled={!hasNext || loading}
        type={IconType.Button}
        fontSize="24px"
        onclick={onClickNext}
        name="pagination-next"
      />
    </div>
  </div>
</div>

<style src="./Pagination.css">
</style>
